// GMO かんたんゲームボックス API の型定義
declare global {
  interface Window {
    game_start?: (options: { callback: string | (() => void) }) => void;
    game_end?: (options: {
      callback: string | (() => void);
      score: number;
    }) => void;
    game_save?: (options: {
      callback: string | (() => void);
      data: string;
    }) => void;
    game_get_data?: (options: {
      callback: string | ((data: { gamedata: string }) => void);
    }) => void;
    show_reward_ad?: (options: {
      reward_success_callback: string | (() => void);
      reward_fail_callback: string | (() => void);
    }) => void;
  }
}

/**
 * game_start API を呼び出す
 * @param callback コールバック関数
 */
export function callGameStart(callback: () => void): void {
  if (window.game_start) {
    window.game_start({ callback });
  } else {
    // 開発環境でのフォールバック
    setTimeout(callback, 100);
  }
}

/**
 * game_end API を呼び出す
 * @param score 最終スコア
 * @param callback コールバック関数
 */
export function callGameEnd(score: number, callback: () => void): void {
  if (window.game_end) {
    window.game_end({ callback, score });
  } else {
    // 開発環境でのフォールバック
    setTimeout(callback, 100);
  }
}

/**
 * game_save API を呼び出す
 * @param data 保存するデータ（JSON文字列）
 * @param callback コールバック関数
 */
export function callGameSave(data: string, callback: () => void): void {
  if (window.game_save) {
    window.game_save({ callback, data });
  } else {
    // 開発環境でのフォールバック（メモリ上のみ）
    setTimeout(callback, 100);
  }
}

/**
 * game_get_data API を呼び出す
 * @param callback コールバック関数
 */
export function callGameGetData(
  callback: (data: { gamedata: string }) => void
): void {
  if (window.game_get_data) {
    window.game_get_data({ callback });
  } else {
    // 開発環境でのフォールバック（デフォルト値を返す）
    setTimeout(() => callback({ gamedata: '{}' }), 100);
  }
}
